<template>
    <div class="control">

        <div class="toolbar-item icon-button " @click="$_open()">
            <Open size="28" />
        </div>

        <div>
            <el-select v-model="ctrlType"  style="width:80px; line-height: 36px;border-radius: 0px; " @change="$_changeCtrlType" size="mini">
                <el-option
                        class="select_item"
                        v-for="item in CtrlOptions"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                ></el-option>
            </el-select>
        </div>

        <ul class="editbutton ul_tools ">
            <li v-for="item in fileList"
                :key="item.index"
                :title="item.title"
                :id="item.name"
                @click.stop="btn(item.name) ">
                <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                <span v-else :class="item.class +' '+ item.pic+'  '"  :style="item.style"></span>
            </li>

        </ul>

        <div class="toolbar-item icon-button " :class="{'selection-active': selectionOpened}" @click="$_selectionSelect()">
            <area-select size="22" />
        </div>

        <div class="toolbar-item icon-button " @click="$_zoomIn()">
            <zoom-in size="22" />
        </div>
        <div class="toolbar-item icon-button " @click="$_zoomOut()">
            <zoom-out size="24" />
        </div>
        <div
                class="toolbar-item"
                :class="{'disabled': !undoAble}"
                @click="$_undo()"
        >
            <step-back size="18" />
        </div>
        <div
                class="toolbar-item"
                :class="{'disabled': !redoAble}"
                @click="$_redo()"
        >
            <step-foward size="18" />
        </div>

        <div>
            <el-select v-model="linetype"  style="width:80px; line-height: 36px;border-radius: 0px; " @change="$_changeLineType" size="mini">
                <el-option
                        class="select_item"
                        v-for="item in lineOptions"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                ></el-option>
            </el-select>
        </div>


        <el-popover ref="pop_list"
                    placement="bottom-end"
                    popper-class="pop_list_content"
                    trigger="click"
        >
            <flowlist ref="flowlist"  :flowlist="flowlistdata" @pagechange="loadFlowList" @flowselect="$_flowSelect" style="height:100%;width:100%;"  ></flowlist>
        </el-popover>
        <el-popover ref="pop_info"
                    :append-to-body="false"
                    :popper-options="{
                      boundariesElement: 'body',
                      gpuAcceleration: true,
                      positionFixed: true,
                      preventOverflow: true
                    }"
                    placement="bottom-end"
                    popper-class="set_pop_info"
                    trigger="click">
            <Info   ref="info" @infoedit="$_flowSetChange"></Info>
        </el-popover>
    </div>
</template>

<script>

    import * as flowUtil from '@/utils/logicFlowJs.js';
    import Info from '../PropertySetting/Info'
    import flowlist from '../flowList/flowlist'

    import Open from '../icon/Open.vue'
    import ZoomIn from '../icon/ZoomIn.vue'
    import ZoomOut from '../icon/ZoomOut.vue'
    import StepBack from '../icon/StepBack.vue'
    import StepFoward from '../icon/StepFoward.vue'
    import AreaSelect from '../icon/AreaSelect.vue'
    const newData = require('./new.json')
    export default {
        props: {
            lf: Object,

        },


        components: {
            // ColorFill,
            // ColorText,
            // IconFont,
            // IconBlod,
            // IconLine,
            flowlist,
            Info,
            Open,
            ZoomIn,
            ZoomOut,
            StepBack,
            StepFoward,
            AreaSelect,

            // SketchPicker: Sketch
        },
        data () {
            return {
                ctrlType:"flow",
                flowSet:{},
                flowdata:{},
                flowlistdata:{},
                selectionOpened: false,
                undoAble: false,
                redoAble: false,
                colors: '#345678',
                linetype: 'polyline',
                lineOptions: [
                    {
                        value: 'polyline',
                        label: '折线'
                    },
                    {
                        value: 'line',
                        label: '直线'
                    },
                    {
                        value: 'bezier',
                        label: '曲线'
                    }
                ],
                CtrlOptions: [
                    {
                        value: 'flow',
                        label: '流程'
                    },
                    {
                        value: 'panel',
                        label: '区域'
                    },
                    {
                        value: 'manage',
                        label: '生产'
                    }
                ],
                fileList:{divider:{class:'divider'},new:{name:'new',title:'新建',data:1,style:'padding:4px ;font-size:26px',pic:'icon-wenjian1',class:'font-button iconfontcolor'},newCopy:{name:'copy',title:'复制新建',data:1,style:'padding:4px;font-size:26px',pic:'icon-light-component-filedeal-copyfile',class:'font-button iconfontcolor'},save:{name:'save',title:'保存',data:1,style:'padding:2px 1px;font-size:28px',pic:'icon-autosave',class:'font-button iconfontcolor'}},

            }
        },
        mounted () {
            this.$props.lf.on('history:change', ({ data: { undoAble, redoAble } }) => {
                this.$data.redoAble = redoAble
                this.$data.undoAble = undoAble
            })
            //
        },
        methods: {
            $_render(data) {
                //console.log("loadTemplate- $_render")
                this.$props.lf.render(data)
                // this.$_LfEvent()
            },
            $_open() {
                 if (this.$refs.pop_list.showPopper)
                     this.$refs.pop_list.showPopper=false
                else
                 this.loadFlowList(1);

            },
            $_reset(){
                this.$props.lf.resetZoom();
                this.$props.lf.resetTranslate();
            },
            $_saveGraph() {
                this.$emit('saveGraph')
            },
            $_zoomIn() {
                this.$props.lf.zoom(true)
            },
            $_zoomOut() {
                this.$props.lf.zoom(false)
                let param = {"stepid": 35450,"table":"jxc_j_main", "mdKey": "","busType":"normal","data":{}};
                this.stepTest(param);
            },
            $_undo() {
                if (this.$data.undoAble) {
                    this.$props.lf.undo()
                }
            },
            $_redo() {
                if (this.$data.redoAble) {
                    this.$props.lf.redo()
                }
            },
            $_selectionSelect() {
                this.selectionOpened = !this.selectionOpened
                if (this.selectionOpened) {
                    this.lf.extension.selectionSelect.openSelectionSelect()
                } else {
                    this.lf.extension.selectionSelect.closeSelectionSelect()
                }

            },
            $_changeLineType(value) {
                //console.log(value);
                const {lf, activeEdges} = this.$props
                const {graphModel} = lf
                lf.setDefaultEdgeType(value)
                if (activeEdges && activeEdges.length > 0) {
                    activeEdges.forEach(edge => {
                        graphModel.changeEdgeType(edge.id, value)
                    })
                }
            },
            $_changeCtrlType(value) {
                this.$emit('setCtrlType',value);
                //console.log(value);
            },
            closeShow(){
                this.$refs.pop_list.showPopper =false;
            },
            btn(id) {
                if (id == undefined) return;
                let id_family = id.split("-");
                let sid = id_family[1];
                switch (id_family[0]) {
                    case 'save':
                        this.saveFlowTemplate()
                        break;
                    case 'new':
                        this.$_reset();
                        this.$refs.pop_info.showPopper =true;
                        this.$refs.info.init({});
                        let newflow={"id":0,"filename":"未命名","fid":"","fileType":"flow","file_json":{}};
                        this.flowdata=newflow;
                        //console.log("this.newData",this.flowdata,newData);
                        this.$_render(newData);
                        break;
                    case 'copy':
                        let param = {"key": 503,"table":"jxc_jx_sqfukzj", "mdKey": "","busType":"payment","data":{},"i_step":36760};
                        this.flowTest(param);

                        break;
                    default:

                        break;
                }
            },

            //load报表模板
            async loadTemplateFromSvr(fid) {

                let param = {"fid": fid};

                let res = await flowUtil.loadDataFromSvr(param);
                if (res.code == 1) {
                    this.$_reset();
                    //console.log("load ok", res);
                    let json=res.json;
                    let set=json.hasOwnProperty("set")?json.set:{};
                    let graphData={};
                    graphData.nodes=json.nodes;
                    graphData.edges=json.edges;
                    this.flowdata.file_json = graphData;
                    this.flowdata.filename = res.name;
                    this.flowdata.i_id=res.id;
                    this.flowdata.fid = fid;
                    this.$refs.pop_info.showPopper =true;
                    this.$refs.info.init(set);
                    this.flowSet=set;
                    this.$emit('setFlowData',set);
                    //console.log("ok graphData",this.flowSet);
                    this.$_render(graphData);
                    // this.$refs.mydialog.showDialog({text:"报表保存成功"});

                } else {
                    // this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});
                }
            },
            //load报表模板
            async saveFlowTemplate() {
                let set=this.$refs.info.getData();
                //console.log("save-info",set);
                this.flowdata.file_json = this.$props.lf.getGraphData();
                this.flowdata.file_json.set=set;
                this.flowdata.fileType="flow";

                let res = await flowUtil.saveFlowTemplate(this.flowdata);
                if (res.code == 1) {
                    //console.log("ok")

                    // this.$refs.mydialog.showDialog({text:"报表保存成功"});

                } else {
                    //console.log(res)
                    // this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});
                }
            },

            //loadFlow模板
            async loadFlowList(page) {

                //console.log("loadTemplate")
                // return;
                // this.rptParm.file_json=sJson;
                // this.rptParm.filename=sJson.set.info.name;
                // let p={"id":10,"name":"asv","金额":30000};
                let param = {"page_size": page, "page_count": 10};
                let res = await flowUtil.loadFlowList(param);
                if (res.code == 1) {
                    //console.log("ok", res)
                    // this.flowlistdata=res;
                    this.flowlistdata=res;
                    this.$refs.pop_list.showPopper =true;

                    // this.$emit('openFile',res)

                } else {
                    //console.log("err", res)
                    // this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});
                }
            },

            //load报表模板
            async flowTest(p) {
                // const fid=this.flowdata.fid;
                // //console.log("loadTemplate",this.flowdata)
                // // return;
                // // this.rptParm.file_json=sJson;
                // // this.rptParm.filename=sJson.set.info.name;
                //  let p={"id":100,"name":"abcd","金额":30000};
                // p.fid=this.flowdata.fid;
                //console.log("loadTemplate",p)
                let res = await flowUtil.getFlowNodeState(p);
                if (res.code == 1) {
                    //console.log("ok", res)
                    // this.flowlistdata=res;

                    // this.$emit('openFile',res)

                } else {
                    //console.log("err", res)
                    // this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});
                }
            },
            //stepTest
            async stepTest(p) {
                // const fid=this.flowdata.fid;
                // console.log("loadTemplate",this.flowdata)
                // // return;
                // // this.rptParm.file_json=sJson;
                // // this.rptParm.filename=sJson.set.info.name;
                //  let p={"id":100,"name":"abcd","金额":30000};
                // p.fid=this.flowdata.fid;
                //console.log("loadTemplate",p)
                let res = await flowUtil.getFlowStepState(p);
                if (res.code == 1) {
                    //console.log("ok", res)
                    // this.flowlistdata=res;

                    // this.$emit('openFile',res)

                } else {
                    // this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});
                }
            },


            $_flowSelect(id){
                 this.loadTemplateFromSvr(id);
            },
            $_flowSetChange(set){
                this.flowSet=set;
                this.$emit('setFlowData',set);
            }
        }
    }
</script>

<style scoped>
    .ul_tools {
        display: flex;
        float: left;
    }

    .control {
        height:38px;
        display: flex;
        float: left;
    }

    .toolbar-item {
        text-align: center;

        display: flex;
        float: left;
        margin: 4px 4px;
        cursor: pointer;
    }
    .icon-button:hover {
        background: #d3d3d3;

    }
    .font-button {
        margin-top:5px;
        padding: 5px 5px;
        color: #016277;
        font-size: 14pt;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .font-checked {
        background: #f6e3ac;

    }
    .font-button:hover {
        background: #babdbf;
        pointer-events:auto;
    }
    .font-disable {
        opacity: 0.5;
        pointer-events:none;
    }
    .zhedie-button {
        width:6px;
        margin:0px;
        padding: 11px 0px ;
        color: #4a8587;
        background: #f2f2f2;
        font-size: 16px;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:38px;
    }
    .zhedie-button:hover {
        background: #f6e3ac;
        pointer-events:auto;
    }
    .dp-left-button {
        padding-right: 0;
        margin-right: 0px;
        text-align: center;
        line-height:36px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:20px;
    }

    .dp-left-button:hover {
        background: #d3d3d3
    }
    .dp-right-button {
        text-align: center;
        line-height:36px;
        font-size: 15px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:15px;
    }
    .dp-right-button:hover {
        background: #d3d3d3
    }
    .select_item{
        font-size: 9px;
    }

</style>
